import { Routes } from '@angular/router';
import {CandidateProfileComponent} from "./candidate-profile/candidate-profile.component";
import {MsalGuard} from "@azure/msal-angular";
import {authGuard} from "./guard/auth.guard";
import {AppComponent} from "./app.component";
import {ErrorComponent} from "./error/error.component";

export const routes: Routes = [
  {path: '', component: AppComponent, canActivate: [MsalGuard], children : [
      {path: '', redirectTo: '', pathMatch: 'full'},
      {path: '', component: CandidateProfileComponent, canActivate: [authGuard]}
    ]},
  {path: 'error', component: ErrorComponent},
  {path: '**', redirectTo: ''}
];
